<template lang="pug">
yz-dialog(v-model="showDialog" max-width="1000" persistent scrollable)
  yz-card
    yz-dialog-normal-header(title="Override default pricing" @close="onClose")

    yz-dialog-normal-content.pa-6
      v-form(ref="form")
        //- Section 1: Branch selection
        .yz-heading-8.text-neutral-700 Select your preferred branches
        .yz-regular-body-sm.text-neutral-500.mt-1 This pricing will override the default pricing and adjusted according to your selected branches and pricing setup.
        yz-card.mt-4(outlined :style="branchError ? 'border-color: var(--yz-danger-500)' : ''")
          .pa-4
            yz-checkbox-group(v-model="selectedBranches" direction="horizontal" :spacing="0")
              v-row(no-gutters)
                v-col.pa-2(v-for="branch in branches" :key="branch.companyId" cols="4")
                  yz-tooltip(:disabled="isEditMode || branch.enabled" text="Turn on this branch to add override pricing" direction="top")
                    yz-checkbox(:value="branch.companyId" :label="branch.name" :disabled="isEditMode || !branch.enabled")
        .yz-regular-body-xs.text-danger-500.mt-1(v-if="branchError") Please select at least one branch

        //- Section 2: Override pricing fields
        .yz-heading-8.text-neutral-700.mt-6 Override default pricing
        .yz-regular-body-sm.text-neutral-500.mt-1 This pricing will override the default pricing and adjusted according to your selected branches and pricing setup.
        v-row.mt-3
          v-col(cols="12" sm="4")
            .yz-heading-9.text-neutral-500 Price
            yz-text-field.mt-2(v-model="overridePrice" placeholder="0" size="lg" :prefix="currency.symbol" type="number" :rules="[v => (v !== null && v !== '' && Number(v) >= 0) || 'This field is required']")
          v-col(cols="12" sm="4")
            .yz-heading-9.text-neutral-500 Bundle value
            yz-text-field.mt-2(:value="bundleValue" placeholder="0" size="lg" :prefix="currency.symbol" type="number" readonly disabled background-color="neutral-300")
          v-col(cols="12" sm="4")
            .yz-heading-9.text-neutral-500 Discount
            yz-text-field.mt-2(:value="overrideDiscount" placeholder="0" size="lg" suffix="%" type="number" readonly disabled background-color="neutral-300")

    yz-dialog-normal-actions(@cancel="onClose" @save="onSave")
</template>

<script>
export default {
  props: {
    open: { type: Boolean, default: false },
    branches: { type: Array, default: () => [] },
    currency: { type: Object, default: () => ({}) },
    bundleValue: { type: String, default: null },
    existingOverride: { type: Object, default: null },
  },
  data () {
    return {
      selectedBranches: [],
      overridePrice: null,
      branchError: false,
    }
  },
  computed: {
    showDialog: {
      get () { return this.open },
      set (val) { this.$emit('update:open', val) },
    },
    isEditMode () {
      return !!this.existingOverride
    },
    overrideDiscount () {
      if (!this.bundleValue || !this.overridePrice || Number(this.bundleValue) === 0) return null
      const perc = ((Number(this.bundleValue) - Number(this.overridePrice)) / Number(this.bundleValue)) * 100
      if (perc <= 0) return null
      return Number.isInteger(perc) ? perc : parseFloat(perc.toFixed(2))
    },
  },
  watch: {
    open (val) {
      if (val && this.existingOverride) {
        this.selectedBranches = [...this.existingOverride.branches]
        this.overridePrice = this.existingOverride.price
      } else if (val) {
        this.selectedBranches = []
        this.overridePrice = null
        this.branchError = false
      }
    },
    selectedBranches () {
      if (this.selectedBranches.length > 0) this.branchError = false
    },
  },
  mounted () {
    if (this.existingOverride) {
      this.selectedBranches = [...this.existingOverride.branches]
      this.overridePrice = this.existingOverride.price
    }
  },
  methods: {
    onClose () {
      this.selectedBranches = []
      this.overridePrice = null
      this.branchError = false
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.showDialog = false
      this.$emit('closed')
    },
    onSave () {
      const formValid = this.$refs.form.validate()
      if (this.selectedBranches.length === 0) {
        this.branchError = true
      }
      if (!formValid || this.selectedBranches.length === 0) return
      this.$emit('save', {
        branches: [...this.selectedBranches],
        price: this.overridePrice,
      })
    },
  },
}
</script>
